import {
  faBan,
  faCheckCircle,
  faClock,
  faCube,
  faExclamationTriangle,
  faTruck,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Group, Text, Tooltip } from '@mantine/core'
import { get } from 'lodash'
import React, { ReactElement } from 'react'

import { useInlineTrackingStore } from '../InlineTracking/useInlineTrackingStore'
import { colors, getIndependendStatus } from '../OrderDetail/Status/status'

type BarcodeProps = {
  coli: any
  coliState: any
  isPickup: boolean
  trackingHash?: string
  zip?: string
  weight?: number
}

export const Barcode = (props: BarcodeProps): ReactElement => {
  const { coli, coliState, isPickup, trackingHash, zip, weight } = props

  const { open, isActive: isInlineTrackingActive } = useInlineTrackingStore()

  const isInlineTrackingAllowed = isInlineTrackingActive

  const openTrackingPopup = (): void => {
    if (!isInlineTrackingAllowed) return
    open({ barcode: coli.barcode1, zip })
  }

  const status = coli.isCancelled
    ? 'cancelled'
    : getIndependendStatus(coliState, isPickup)

  const text = {
    waiting: i18n.t('status_wait_for_pickup', 'Warten auf Abholung'),
    inprogress: i18n.t('status_in_progress', 'Unterwegs'),
    success: i18n.t('status_success', 'Abgeschlossen'),
    error: i18n.t('status_error', 'Probleme'),
    cancelled: i18n.t('status_cancelled', 'Storniert'),
    unknown: i18n.t('status_created', 'Erfasst'),
  }

  const message = get(text, status)

  const icons = {
    waiting: faClock,
    inprogress: faTruck,
    success: faCheckCircle,
    error: faExclamationTriangle,
    cancelled: faBan,
    unknown: faCube,
  }

  return (
    <>
      <Group noWrap spacing="xs">
        <Tooltip label={message} withinPortal withArrow>
          <Text color={get(colors, status)}>
            <FontAwesomeIcon icon={get(icons, status)} />
          </Text>
        </Tooltip>
        <Tooltip
          label={i18n.t(
            'click_to_open_tracking_in_popup',
            'Klicken um Tracking in Popup zu öffnen',
          )}
          withArrow
          withinPortal
          disabled={!isInlineTrackingAllowed}
        >
          <Text
            style={{ cursor: isInlineTrackingAllowed ? 'pointer' : '' }}
            onClick={() => openTrackingPopup()}
          >
            {coli.barcode1}{' '}
            {weight && (
              <Text
                color="dimmed"
                size="xs"
                span
                style={{ whiteSpace: 'nowrap' }}
              >
                ({weight} kg)
              </Text>
            )}
          </Text>
        </Tooltip>
        {/* {coli.isCancelled && <Badge color="red">Storniert</Badge>} */}
      </Group>
    </>
  )
}
